import React from 'react';
import './Logo.css';

const Logo = () => (
  <span className="brand">
    <span className="brand-mark" aria-hidden="true">
      <svg viewBox="0 0 32 32" width="32" height="32">
        <rect x="1" y="1" width="30" height="30" rx="9" fill="var(--accent)" />
        <path
          d="m11 11-4 5 4 5M21 11l4 5-4 5M17.5 9.5l-3 13"
          fill="none"
          stroke="var(--accent-ink)"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
    <span className="brand-name">
      escr<span className="brand-dot">.</span>
    </span>
  </span>
);

export default Logo;
